import Vue from "vue";
import { namespace } from "vuex-class";
import Component from "vue-class-component";
import { ACTION_TYPES } from "@/lib/const";
import {
  InputPaymentSystemCreate,
  InputPaymentSystemUpdate,
  PaymentSystem,
} from "@teacherskaya/api-provider/dist/api/PaymentSystemsProvider";
import { StatePaymentSystems } from "@/store/types";

export const storePath = "paymentSystems";
const Store = namespace(storePath);

@Component
export default class WithPaymentSystems extends Vue {
  @Store.State(state => state)
  public readonly state!: StatePaymentSystems;

  @Store.Getter("getTestSystems")
  public getTestSystems!: () => PaymentSystem[];

  @Store.Getter("hasSetSystem")
  public hasSetSystem!: () => boolean;

  @Store.Action(ACTION_TYPES.GET_DATA)
  public paymentSystemsFindAll!: () => Promise<PaymentSystem[]>;

  @Store.Action(ACTION_TYPES.ADD_DATA)
  public paymentSystemsCreate!: (payload: { data: InputPaymentSystemCreate }) => Promise<PaymentSystem>;

  @Store.Action(ACTION_TYPES.SET_DATA)
  public paymentSystemsUpdate!: (payload: { data: InputPaymentSystemUpdate }) => Promise<PaymentSystem>;

  @Store.Action(ACTION_TYPES.DEL_DATA)
  public paymentSystemsDeleteSystem!: (payload: { id: string }) => Promise<boolean>;
}
